/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CardTypeConsentDTO,
    CardTypeConsentDTOFromJSON,
    CardTypeConsentDTOToJSON,
    ConsentDTO,
    ConsentDTOFromJSON,
    ConsentDTOToJSON,
    PageLogEventEntity,
    PageLogEventEntityFromJSON,
    PageLogEventEntityToJSON,
} from '../models';

export interface GetGroupForPersonRequest {
    personId: string;
    size: number;
    page: number;
    sort: string;
}

export interface GetNameForPersonRequest {
    carePrincipalId: string;
    personId: string;
}

export interface GetPersonsConsentRequest {
    carePrincipalId: string;
    personId: string;
    cardTypeId: string;
}

export interface GroupPersonRequest {
    carePrincipalId: string;
    personId: string;
    cardSystemId: string;
}

export interface UnGroupPersonRequest {
    carePrincipalId: string;
    personId: string;
    cardSystemId: string;
}

export interface UpdatePersonsConsentRequest {
    carePrincipalId: string;
    personId: string;
    cardTypeId: string;
    consentDTO: ConsentDTO;
}

/**
 * 
 */
export class PersonApi extends runtime.BaseAPI {

    /**
     */
    async getGroupForPersonRaw(requestParameters: GetGroupForPersonRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PageLogEventEntity>> {
        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getGroupForPerson.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling getGroupForPerson.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling getGroupForPerson.');
        }

        if (requestParameters.sort === null || requestParameters.sort === undefined) {
            throw new runtime.RequiredError('sort','Required parameter requestParameters.sort was null or undefined when calling getGroupForPerson.');
        }

        const queryParameters: any = {};

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/person/{personId}/group`.replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageLogEventEntityFromJSON(jsonValue));
    }

    /**
     */
    async getGroupForPerson(personId: string, size: number, page: number, sort: string, initOverrides?: RequestInit): Promise<PageLogEventEntity> {
        const response = await this.getGroupForPersonRaw({ personId: personId, size: size, page: page, sort: sort }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getNameForPersonRaw(requestParameters: GetNameForPersonRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getNameForPerson.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getNameForPerson.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/name/person/{personId}`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))).replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getNameForPerson(carePrincipalId: string, personId: string, initOverrides?: RequestInit): Promise<string> {
        const response = await this.getNameForPersonRaw({ carePrincipalId: carePrincipalId, personId: personId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPersonsConsentRaw(requestParameters: GetPersonsConsentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<CardTypeConsentDTO>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling getPersonsConsent.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling getPersonsConsent.');
        }

        if (requestParameters.cardTypeId === null || requestParameters.cardTypeId === undefined) {
            throw new runtime.RequiredError('cardTypeId','Required parameter requestParameters.cardTypeId was null or undefined when calling getPersonsConsent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/person/{personId}/cardtype/{cardTypeId}/consent`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))).replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))).replace(`{${"cardTypeId"}}`, encodeURIComponent(String(requestParameters.cardTypeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CardTypeConsentDTOFromJSON(jsonValue));
    }

    /**
     */
    async getPersonsConsent(carePrincipalId: string, personId: string, cardTypeId: string, initOverrides?: RequestInit): Promise<CardTypeConsentDTO> {
        const response = await this.getPersonsConsentRaw({ carePrincipalId: carePrincipalId, personId: personId, cardTypeId: cardTypeId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async groupPersonRaw(requestParameters: GroupPersonRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling groupPerson.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling groupPerson.');
        }

        if (requestParameters.cardSystemId === null || requestParameters.cardSystemId === undefined) {
            throw new runtime.RequiredError('cardSystemId','Required parameter requestParameters.cardSystemId was null or undefined when calling groupPerson.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/person/{personId}/cardsystem/{cardSystemId}/group`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))).replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))).replace(`{${"cardSystemId"}}`, encodeURIComponent(String(requestParameters.cardSystemId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async groupPerson(carePrincipalId: string, personId: string, cardSystemId: string, initOverrides?: RequestInit): Promise<string> {
        const response = await this.groupPersonRaw({ carePrincipalId: carePrincipalId, personId: personId, cardSystemId: cardSystemId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async unGroupPersonRaw(requestParameters: UnGroupPersonRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling unGroupPerson.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling unGroupPerson.');
        }

        if (requestParameters.cardSystemId === null || requestParameters.cardSystemId === undefined) {
            throw new runtime.RequiredError('cardSystemId','Required parameter requestParameters.cardSystemId was null or undefined when calling unGroupPerson.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/person/{personId}/cardsystem/{cardSystemId}/ungroup`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))).replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))).replace(`{${"cardSystemId"}}`, encodeURIComponent(String(requestParameters.cardSystemId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async unGroupPerson(carePrincipalId: string, personId: string, cardSystemId: string, initOverrides?: RequestInit): Promise<string> {
        const response = await this.unGroupPersonRaw({ carePrincipalId: carePrincipalId, personId: personId, cardSystemId: cardSystemId }, initOverrides);
        return await response.value();
    }

    /**
     */
    async updatePersonsConsentRaw(requestParameters: UpdatePersonsConsentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling updatePersonsConsent.');
        }

        if (requestParameters.personId === null || requestParameters.personId === undefined) {
            throw new runtime.RequiredError('personId','Required parameter requestParameters.personId was null or undefined when calling updatePersonsConsent.');
        }

        if (requestParameters.cardTypeId === null || requestParameters.cardTypeId === undefined) {
            throw new runtime.RequiredError('cardTypeId','Required parameter requestParameters.cardTypeId was null or undefined when calling updatePersonsConsent.');
        }

        if (requestParameters.consentDTO === null || requestParameters.consentDTO === undefined) {
            throw new runtime.RequiredError('consentDTO','Required parameter requestParameters.consentDTO was null or undefined when calling updatePersonsConsent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/person/{personId}/cardtype/{cardTypeId}/consent`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))).replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters.personId))).replace(`{${"cardTypeId"}}`, encodeURIComponent(String(requestParameters.cardTypeId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ConsentDTOToJSON(requestParameters.consentDTO),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updatePersonsConsent(carePrincipalId: string, personId: string, cardTypeId: string, consentDTO: ConsentDTO, initOverrides?: RequestInit): Promise<void> {
        await this.updatePersonsConsentRaw({ carePrincipalId: carePrincipalId, personId: personId, cardTypeId: cardTypeId, consentDTO: consentDTO }, initOverrides);
    }

}
